import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/solid";

const BrandsRowDetails = ({ details, onCheckboxChange, isSelected }) => {
  const values = [
    details.number,
    details.nameEN,
    details.nameAR,
    details.link,
    details.img,
    details.areaName,
    details.categoryName,
    details.subCategoryName,
  ];
  // console.log(values)
  // console.log(details)

  return (
    <tr className="text-sm text-center text-gray-800 bg-white h-[60px]">
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          {/* <button onClick={onDelete} type="check box">
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button> */}
          <td className="px-2 py-2">
            <div className="flex justify-around space-x-2">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={(e) => onCheckboxChange(details.id, e.target.checked)}
                className="w-5 h-5 text-red-600"
              />
            </div>
          </td>
        </div>
      </td>
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 10 ? (
            <span title={value} className="text-black cursor-pointer">
              <InformationCircleIcon className="inline-block w-5 h-5 cursor-pointer text-custom-yellow" />
              Hover
            </span>
          ) : index === 4 ? (
            <img
              src={value}
              alt="Image"
              className="object-cover w-10 mx-auto"
            />
          ) : index === 3 ? (
            <span title={value} className="text-black cursor-pointer">
              <a
                href={value}
                className="px-2 py-1 text-black duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-100"
              >
                {values[1]}
              </a>
            </span>
          ) : (
            value
          )}
        </td>
      ))}
    </tr>
  );
};

export default BrandsRowDetails;
